import { useMemo } from "react";
import TspApiService from "../../api/tspApiService";
import useTspPagedList from "../../hooks/useTspPagedList";
import { MEDIA_PAGE_SIZE, TAB_TO_TYPE, buildUploadForm } from "./mediaModel";

const EMPTY_COUNTS = { all: 0, images: 0, videos: 0 };

// The Media Gallery's data: one server-filtered, server-paged list. Search /
// journey / city / type are sent to the API — nothing is fetched wholesale and
// filtered in the browser. filters: { search, journeyId, locationId, tab }
export default function useTspMediaList(filters) {
  const params = useMemo(
    () => ({
      q: filters.search.trim() || undefined,
      journey_id: filters.journeyId || undefined,
      location_id: filters.locationId || undefined,
      type: TAB_TO_TYPE[filters.tab] || undefined,
    }),
    [filters.search, filters.journeyId, filters.locationId, filters.tab]
  );
  const list = useTspPagedList((page) => TspApiService.media.list({ ...params, page, limit: MEDIA_PAGE_SIZE }), JSON.stringify(params));
  return { ...list, counts: list.meta?.counts || EMPTY_COUNTS };
}

// Mutations. Each throws the axios error on refusal so the caller can show the
// server's own reason (see tspErrorMessage).
export const uploadMedia = (values, file) => TspApiService.media.upload(buildUploadForm(values, file));
export const removeMedia = (id) => TspApiService.media.remove(id);
